const ActivitiesNameSearch = ({ searchInput, handleSearchInput }) => {
    return (
        <div className="flex gap-2 w-full md:w-fit my-8">
            <i className="fi fi-br-search text-2xl mt-5"></i>
            <input type="text" id="activities-string" value={searchInput} onChange={handleSearchInput} className="w-full" />
        </div>
    )
}

export default ActivitiesNameSearch;